<template>
  <div class="ml-layout">
    <NotificationPopup />

    <!-- Sidebar Menu -->
    <aside :class="['ml-sidebar', { 'ml-sidebar-hidden': isMobile && !menuOpen }]">
      <nav>
        <LeftMenu />
      </nav>
    </aside>

    <!-- Main Area -->
    <div class="ml-main-content">
      <!-- Topbar -->
      <header class="ml-topbar">
       
        <UserTopbar @toggle_menu="toggle_menu" />
      </header>

      <!-- Page Content -->
      <section class="ml-content">
        <transition name="fade-in-up">
          <router-view />
        </transition>
      </section>

      <!-- Footer -->
      <footer class="ml-footer">
        <UserFooter />
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { parseJwt } from '@/core/services/jwt.service';
import { initUserMemlist } from '@/core/services/initUserMemlist.js';
import dayjs from 'dayjs';
import LeftMenu from '@/view/layout/aside/LeftMenu.vue';
import UserTopbar from './header/UserTopbar.vue';
import UserFooter from './footer/UserFooter.vue';
import NotificationPopup from '@/view/components/NotificationPopup.vue';


export default {
  name: 'UserLayout',
  components: {
    LeftMenu,
    UserFooter,
    UserTopbar,
    NotificationPopup,
  },
  data() {
    return {
      menuOpen: false,
      isMobile: false,
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'breadcrumbs', 'pageTitle', 'layoutConfig','ulogin_link', 'user_refresh_token']),
  },

  watch: {

    isAuthenticated(newValue) {
      console.error('Layout.vue: detected authentication state change', newValue);
    }
  },
  mounted() {

    this.check_refresh_token_expired();

    console.log('Initializing Layout initUserMemlist');

    initUserMemlist((auth, init) => {
      console.error('Layout.vue: initUserMemlist', auth, init);
    });

    this.interval_id = setInterval(this.check_refresh_token_expired, 1000 * 60);

    this.checkViewport();
    window.addEventListener('resize', this.checkViewport);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkViewport);
  },
  methods: {

    check_refresh_token_expired() {
      
      try {
        if (!this.user_refresh_token || this.user_refresh_token.length < 16) {
          console.error('check_refresh_token_expired invalid user refresh token view/Layout', this.user_refresh_token);
          return;
        }

        const parsed = parseJwt(this.user_refresh_token);

        const cd = dayjs.unix(parsed.exp);
        const now = dayjs().add(1, 'minute');

        console.log('refresh token will expire at ', cd.format('YYYY-MM-DD HH:mm:ss'), 'now is', now.format('YYYY-MM-DD HH:mm:ss'));

        if (cd < now) {
          console.log('>> check_refresh_token_expired, User refresh token has expired', cd, now, this.user_refresh_token)

          clearInterval(this.interval_id);

          console.log('>> redirecting');

        }
      }
      catch (err) {
        clearInterval(this.interval_id);
        
        console.error('token has expired with error', err);
        console.log('>> Token expired exception, purging auth');
        
      }

    },

    toggle_menu() {
      this.menuOpen = !this.menuOpen;
    },
    checkViewport() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) this.menuOpen = false;
    },
  },
};
</script>

<style scoped>
.ml-layout {
  display: flex;
  height: 100vh; /* full screen height */
  flex-direction: row;
  overflow: hidden; /* prevent outer scroll */
}

/* Sidebar */
.ml-sidebar {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  background-color: rgb(36, 41, 57);
  height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 1rem;
}

.ml-sidebar-hidden {
  display: none;
}

/* Main content */
.ml-main-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
}
/* Topbar */
.ml-topbar {
  background-color: white;
  display: flex;
}
.ml-hamburger {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 1rem;
}

/* Page Content */
.ml-content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  background: #fafafa;
}

/* Footer */
.ml-footer {
  text-align: center;
  background: #f4f4f4;
  font-size: 14px;
}

/* Responsive behavior */
@media (max-width: 768px) {
  .ml-layout {
    flex-direction: column;
  }

  .ml-sidebar {
    width: 100%;
    position: absolute;
    z-index: 10;
    top: 80px;
    left: 0;
    background-color: #f4f4f4;
    border-top: 1px solid #ddd;
  }

  .ml-main-content {
    width: 100%;
  }
}
</style>
